/* eslint jsx-a11y/label-has-associated-control: 0 */
/* eslint jsx-a11y/control-has-associated-label: 0 */
import React, { useState } from "react";

import IField from "../../../../interfaces/field";
import TplGroup from "../tpl-group";
import Icons from "../../../icons-helper";

import {
  NameWrapper,
  Upload,
  DownloadButton,
  ContainerFile,
  ChangeButton,
} from "./styles";

import { theme } from "../../../../styles/theme";

type IProps = any & IField;

const InputUpload: React.FC<IProps> = ({
  title,
  required = false,
  name,
  prefixName = "",
  // hasPreview = true,
  accept = "*",
  hasPreview = false,
  url = "",
  ...el
}: IProps) => {
  const [fileInputed, setFileInputed] = useState<File | null>(null);

  const [wannaChange, setWannaChange] = useState(false);

  const toggleWannaChange = (): void => {
    setWannaChange(!wannaChange);
  };

  const onChange = (evt: any): void => {
    const file: File = evt.target.files[0];
    setFileInputed(file);

    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, file);
    }
  };

  // const onLoadImg = (evt: any) => {
  //   const { naturalWidth, naturalHeight } = evt.target
  //   const dimension = `${naturalWidth}px x ${naturalHeight}px`
  //   setImgDimensions(dimension)
  // }

  const handleDownloadFile = (): void => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handleRemoveFile = (): void => {
    setFileInputed(null);
    el.setFieldValue(`${prefixName}${name}`, "");
  };

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      {/* <If condition={hasPreview}>
        <Thumb>
          <ThumbImageWrapper>
            {
              fileInputed || fileByApi
                ? (<ThumbImage src={imgURL} onLoad={onLoadImg} />)
                : <Icon name="upload" />
            }
          </ThumbImageWrapper>
        </Thumb>
      </If> */}
      {hasPreview && !wannaChange ? (
        <ContainerFile>
          <DownloadButton type="button" onClick={handleDownloadFile}>
            <Icons
              name="download"
              width={20}
              height={20}
              color={theme.colors.white}
            />
            Vizualizar Certificado Digital
          </DownloadButton>
          <ChangeButton type="button" onClick={toggleWannaChange}>
            Trocar de Certificado
          </ChangeButton>
        </ContainerFile>
      ) : (
        <Upload>
          <div>
            <label htmlFor={name}>
              <Icons
                name="upload"
                width={20}
                height={20}
                color={theme.colors.white}
              />
              Novo arquivo
            </label>
            <input
              required={required}
              onChange={onChange}
              type="file"
              name={`${prefixName}${name}`}
              id={name}
              accept={accept}
            />
            {fileInputed && (
              <NameWrapper>
                <span>{fileInputed?.name}</span>
                <button type="button" onClick={handleRemoveFile}>
                  <Icons
                    name="close"
                    width={16}
                    height={16}
                    color={theme.colors.white}
                  />
                </button>
              </NameWrapper>
            )}
          </div>
        </Upload>
      )}
    </TplGroup>
  );
};

export default InputUpload;
